var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTag = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.796 8.11 6.928 1.243a.918.918 0 0 0-.653-.27h-4.66A1.387 1.387 0 0 0 .23 2.358v4.65a.927.927 0 0 0 .291.674l7.307 6.863a.688.688 0 0 0 .764.125.69.69 0 0 0 .22-.16l5.005-5.44a.691.691 0 0 0-.02-.96ZM8.29 13.713 1.154 7.008v-4.65a.463.463 0 0 1 .462-.462h4.659l6.711 6.711-4.696 5.105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.04 3.282a1.501 1.501 0 1 0 0 3.002 1.501 1.501 0 0 0 0-3.002Zm0 2.079a.577.577 0 1 1 0-1.155.577.577 0 0 1 0 1.155Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "tag.8b01aafcbf3aadc9df279f5260218e1b.svg";